<script setup lang="ts">
import { ref } from "vue";

const backToTop = ref("hidden");

const scrollToTop = () => {
  // Scroll instantané vers le haut
  window.scrollTo({
    top: 0,
    behavior: 'auto' // Instantané au lieu de smooth
  });
};

const showBackToTop = () => {
  backToTop.value = window.pageYOffset > 300
      ? ""
      : "hidden";
};

window.addEventListener("scroll", showBackToTop);
showBackToTop(); // Initialiser
</script>

<template>
  <!-- Bouton Back to Top modernisé avec animation -->
  <button
    class="
      group
      fixed
      bottom-8
      right-8
      z-40
      w-12
      h-12
      flex
      items-center
      justify-center
      bg-gradient-to-br
      from-primary-500
      to-primary-600
      hover:from-primary-600
      hover:to-primary-700
      text-white
      rounded-full
      shadow-lg
      hover:shadow-2xl
      transition-all
      duration-300
      hover:scale-110
      focus-ring
    "
    :class="backToTop"
    @click="scrollToTop"
    aria-label="Retour en haut"
  >
    <!-- Icône avec animation -->
    <fa
      :icon="['fas', 'arrow-up']"
      class="
        text-lg
        group-hover:-translate-y-1
        transition-transform
        duration-300
      "
    />

    <!-- Cercle de progression (optionnel) -->
    <svg
      class="
        absolute
        inset-0
        w-full
        h-full
        -rotate-90
      "
    >
      <circle
        cx="24"
        cy="24"
        r="22"
        stroke="currentColor"
        stroke-width="2"
        fill="none"
        class="
          text-white/30
          transition-all
          duration-300
        "
        stroke-dasharray="138"
        stroke-dashoffset="0"
      />
    </svg>

    <!-- Pulse animation au survol -->
    <span class="
        absolute
        inset-0
        rounded-full
        bg-primary-400
        opacity-0
        group-hover:opacity-30
        group-hover:scale-150
        transition-all
        duration-500
      "></span>
  </button>
</template>
